import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const partnerApi = axios.create({ baseURL: API });
partnerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("juke_partner_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export default partnerApi;
